import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";
import { API_ENDPOINTS } from './apiConfig';
import ProfileDetailsPopup from "./ProfileDetailsPopup";
import { useNavigate } from 'react-router-dom';
import { containsForbiddenContactInfo,cleanForbiddenContactInfo } from './containsForbiddenContactInfo';

const BASE_IMG_URL = API_ENDPOINTS.BASE_PIMG_URL;


const ChatScreen = () => {
  const { token } = useAuth();
  const [conversations, setConversations] = useState([]);
  const [selected, setSelected] = useState(null);
  const [messageText, setMessageText] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const scrollRef = useRef(null);
  const [profilePopupId, setProfilePopupId] = useState(null);
  
  const navigate = useNavigate();

  useEffect(() => {
    fetchConversations(page);
  }, [page]);


  // Fetch conversations again when user exits chat screen
useEffect(() => {

  if (selected === null) {
    fetchConversations(page);
  }
}, [selected]);

// Auto refresh conversations every 1 minute when user is on this screen
useEffect(() => {
  const interval = setInterval(() => {
    if (!selected) {
      fetchConversations(page);
    }
  }, 60000); // 60 seconds

  return () => clearInterval(interval);
}, [selected, page]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [selected?.messages]);


useEffect(() => {
  const fetchAll = async () => {
    try {
      const res = await axios.post(API_ENDPOINTS.GETPPHOTO, {}, {
        headers: { token },
      });

      if (res.status === 200) {
        const { result, detailResult, imgResult, age } = res.data;

        // 🚨 Redirects based on API response
        if (result === 0 && detailResult === 0) {
          navigate('/details');
          return;
        }

        if (result === 0 && imgResult === 0) {
          navigate('/ProfileImageUpload');
          return;
        }

      }

    } catch (err) {
      console.error('Error during initial data fetch:', err);
    }
  };

  fetchAll();
}, []);



// when back to  main screen from the pop then I need to fetch conversation data with out refresh whole page
// when user active on screen this screen then every 1 minutes need to fetch data with out refresh whole page

  const fetchConversations = async (pg) => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.post(
        `${API_ENDPOINTS.MSGGET}`,
        { page: pg },
        { headers: { token } }
      );
      if (res.data.result === 1) {
        setConversations(res.data.data);
      } else {
        setError("Failed to load conversations");
        setConversations([]);
      }
    } catch (err) {
      setError("Error fetching conversations");
      setConversations([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAccept = async (id, acceptValue) => {
    try {
      await axios.post(
        `${API_ENDPOINTS.ACCEPT}`,
        { id, accept: acceptValue },
        { headers: { token } }
      );
      if (selected && selected.id === id) {
        setSelected((prev) => ({
          ...prev,
          accept: acceptValue,
          rejected: acceptValue === 0,
        }));
      }
      fetchConversations(page);
    } catch (err) {
      console.error("Accept error", err);
    }
  };

  const sendMessage = async () => {
    const msg = messageText.trim();

    if(containsForbiddenContactInfo(msg) && selected.share==0)return;



    if (!msg || msg.length > 150) return;

    try {
      await axios.post(
        `${API_ENDPOINTS.SENTMSG}`,
        { id: selected.id, text: msg },
        { headers: { token } }
      );
      const newMsg = {
        mid: `local-${Date.now()}`,
        text: msg,
        dir: 0,
        time: new Date().toISOString(),
        isactive: 1,
      };
      setSelected((prev) => ({
        ...prev,
        messages: [...prev.messages, newMsg],
      }));
      setMessageText("");
    } catch (err) {
      console.error("Message send error", err);
    }
  };

  const renderMessages = (messages) => {
    const sortedMessages = [...messages].sort(
      (a, b) => new Date(a.time) - new Date(b.time)
    );

    return sortedMessages.map((msg, index) => (
      <div
        key={msg.mid || index}
        className={`d-flex ${msg.dir === 0 ? "justify-content-end" : "justify-content-start"}`}
      >
        <div
          className={`p-2 my-1 rounded ${
            msg.dir === 0 ? "bg-pink-light text-dark" : "bg-light border"
          }`}
          style={{ maxWidth: "70%", wordBreak: "break-word" }}
        >
          <div>{msg.text}</div>
          <small className="text-muted d-block text-end">
            {new Date(msg.time).toLocaleTimeString()}
          </small>
        </div>
      </div>
    ));
  };

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{
        background: "linear-gradient(135deg, #ffe0f0, #d0e8ff)",
        padding: "16px",
        paddingTop: "2rem",
      }}
    >
      <div style={{ maxWidth: 480, width: "100%", margin: "0 auto", flex: 1 }}>
        {!selected ? (
          <>
            <h4 className="text-center mb-3" style={{ fontWeight: 700, color: "#d6336c" }}>
              Your Chats
            </h4>

            {loading && <div className="text-center p-3">Loading chats...</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="list-group mb-3">
              {conversations.map((user) => {
                const latestMsg = [...user.messages].sort(
                  (a, b) => new Date(b.time) - new Date(a.time)
                )[0];
                return (
                  <button
                    key={user.id}
                    type="button"
                    className="list-group-item list-group-item-action d-flex align-items-center"
                    onClick={() => setSelected(user)}
                  >
                    <img
                      src={BASE_IMG_URL + user.img}
                      alt={user.name}
                      className="rounded-circle me-3"
                      style={{ width: 50, height: 50, objectFit: "cover" }}
                    />
                    <div className="flex-grow-1 text-start">
                      <div className="fw-bold" style={{ color: "#d6336c" }}>{user.name}</div>
                      <small className="text-muted d-block text-truncate">
                        {latestMsg?.text || "No messages"}
                      </small>
                    </div>
                  </button>
                );
              })}
            </div>

            <div className="d-flex justify-content-center gap-2">
              <button
                className="btn btn-pink"
                disabled={loading || page === 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
              >
                <i className="bi bi-arrow-left"></i> Previous
              </button>
              <button
                className="btn btn-pink"
                disabled={loading || conversations.length === 0}
                onClick={() => setPage((p) => p + 1)}
              >
                Next <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </>
        ) : (
          <div className="modal d-block position-fixed top-0 start-0 w-100 h-100 bg-white" style={{ zIndex: 1055 }}>
            <div className="d-flex flex-column h-100">
              <div className="border-bottom p-3 d-flex justify-content-between align-items-center bg-light">
                <div className="d-flex align-items-center">
                  <button className="btn btn-link text-decoration-none me-3" onClick={() => setSelected(null)}>
                    <i className="bi bi-arrow-left fs-4" style={{ color: "#d6336c" }}></i>
                  </button>


            


<div
  className="d-flex align-items-center cursor-pointer"
  onClick={() => setProfilePopupId(selected.id)}
>
  <img
    src={BASE_IMG_URL + selected.img}
    alt={selected.name}
    className="rounded-circle me-3"
    style={{ width: 50, height: 50, objectFit: "cover" }}
  />
  <strong style={{ color: "#d6336c" }}>{selected.name}</strong>

</div>


{profilePopupId && (
  <ProfileDetailsPopup
    id={profilePopupId}
    token={token}
    onClose={() => setProfilePopupId(null)}
  />
)}





                </div>
                {selected.accept === 1 ? (
                  <button className="btn btn-danger" onClick={() => handleAccept(selected.id, 0)}>
                    <i className="bi bi-x-circle me-1"></i> Reject
                  </button>
                ) : selected.accept === 0 ? (
                  <button className="btn btn-pink" onClick={() => handleAccept(selected.id, 1)}>
                    <i className="bi bi-check-circle me-1"></i> Accept
                  </button>
                ) : null}
                
              </div>

{selected.share === 0 ? (
  <div
  className="mb-2 text-danger small d-flex align-items-start gap-2"
  style={{
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeeba',
    padding: '3px',
    borderRadius: '1px',
    fontSize: '0.50rem',
    lineHeight: '1.5',
  }}
>
  <i className="bi bi-exclamation-triangle-fill mt-1" style={{ color: '#d39e00' }}></i>
  <div>
    <strong>Warning:</strong> Do not share phone numbers, email, or any contact/social handles (e.g. WhatsApp, Instagram, Facebook, Telegram, Snapchat, Twitter, LinkedIn, etc.).
    Violating this rule may result in your account being blocked.
    <strong> AI Engine will automatically allow contact sharing once a meaningful and respectful conversation has been established.</strong>
  </div>
</div> ):(<div></div>)} 


              <div
                className="flex-grow-1 overflow-auto p-3"
                ref={scrollRef}
                style={{ backgroundColor: "#fff0f6" }}
              >
                {selected.messages.length > 0 ? (
                  renderMessages(selected.messages)
                ) : (
                  <div className="text-center text-muted mt-5">No messages yet</div>
                )}
               
              </div>

              {selected.accept === undefined && (
                <div className="p-3 border-top bg-white d-flex justify-content-center gap-3">
                  <button className="btn btn-pink w-50" onClick={() => handleAccept(selected.id, 1)}>
                    <i className="bi bi-check-circle me-1"></i> Accept
                  </button>
                  <button className="btn btn-danger w-50" onClick={() => handleAccept(selected.id, 0)}>
                    <i className="bi bi-x-circle me-1"></i> Reject
                  </button>
                </div>
              )}

            
              {selected.accept === 1 && (
                <div className="p-3 border-top bg-white">
                  {selected.raccept ===1 ? (
                    <div className="d-flex">
                      <input
                        type="text"
                        className="form-control me-2"
                        placeholder="Type your message"
                        value={messageText}
                        maxLength={150}
                        onChange={(e) => setMessageText(e.target.value.replace(/[{}\[\]<>]/g, ""))}
                        onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                      />       
                      <button className="btn btn-pink" onClick={sendMessage}>
                        <i className="bi bi-send-fill me-1"></i> Send
                      </button>
                    </div>
                  ) : (
                    <div className="alert alert-warning text-center">User has not yet accepted your message.
                   
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <style>{`
        .bg-pink {
          background-color: #ff69b4 !important;
        }
        .bg-pink-light {
          background-color: #ffd6e8 !important;
        }
        .btn-pink {
          background-color: #ff69b4;
          color: white;
          border: none;
        }
        .btn-pink:hover {
          background-color: #e0558e;
          color: white;
        }
      `}</style>
    </div>
  );
};

export default ChatScreen;
